import { render } from "./BaseCard.vue?vue&type=template&id=12ff3f36&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=12ff3f36&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ff3f36"]])

export default __exports__